import { render, staticRenderFns } from "./CustomerINA.vue?vue&type=template&id=9a5e2b62&functional=true&"
import script from "./CustomerINA.vue?vue&type=script&lang=js&"
export * from "./CustomerINA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports